document.addEventListener("DOMContentLoaded", function() {
	
    // Membership tags for validation
    var membershipTags = ['Copper4', 'Copper6', 'Silver4', 'Silver6', 'Select4', 'Select6', 'Gold4', 'Gold6', 'Premium4', 'Premium6', 'Platinum4', 'Platinum6', 'Ultimate4', 'Ultimate6', 'Palladium4', 'Palladium6', 'VIPMK6'];
    var customerId    = window.customerId || 'guest';
    var customerEmail = window.customerEmail || 'guest@example.com';
    var customerTags = window.customerTags || [];
    //console.log('Customer ID:', customerId);
    //console.log('Customer Email:', customerEmail);
    console.log('Customer Tags raw:', window.customerTags);
    console.log('Customer Tags:', customerTags);
  
	// Define shared button options for Protein Size and Taco Quantity
	var button_1 = { "Protein Size": "4oz", "Quantity": "2 Tacos" };
	var button_2 = { "Protein Size": "6oz", "Quantity": "3 Tacos" };

	// Check if the customer is signed in and has a membership tag
    var membershipLevel = membershipTags.find(tag => customerTags.includes(tag)) || null;
    
    // Extract the allowed size from the last character of the membershipLevel
	var allowedSize = membershipLevel ? membershipLevel.slice(-1) : null;  // e.g., '4' or '6'
	
	// You can now use `allowedSize` in the rest of your logic
	console.log('Customer Membership Level:', membershipLevel);
	console.log('Allowed Size:', allowedSize);

    // Store the number of Qualifying Items and the Calculated Total Savings globally
    let totalQualifyingItems = 0;
	let totalCostOfQualifyingMeals = 0;

	// Exit if customer is not signed in or does not have a membership tag
    if (customerId === 'guest' || !membershipLevel) {
        console.log("Customer is either not signed in or does not have a membership tag. Skipping membership logic.");
        return;
    }

	// Get the local time of the Customer
	function getLocalDate() {
	    const now     = new Date();
	    const year    = now.getFullYear().toString().slice(2);
	    const month   = (now.getMonth() + 1).toString().padStart(2, '0');
	    const day     = now.getDate().toString().padStart(2, '0');
	    const hours   = now.getHours().toString().padStart(2, '0');
		const minutes = now.getMinutes().toString().padStart(2, '0');
		const seconds = now.getSeconds().toString().padStart(2, '0');
	
	    return `${year}${month}${day}${hours}${minutes}${seconds}`;
	}
	
	// Generate a unique Discount Code for the Customer
	function generateDiscountCodeString(customerId, membershipLevel) {
	    return `${membershipLevel}-${customerId}-${getLocalDate()}`;
	}
	
    // Define the product handles to exclude from included meal limits
    var excludedHandles = [
        "4oz-chefs-choice-8-meal-bundle",
        "6oz-chefs-choice-8-meal-bundle",
        "carbs-a-la-carte",
        "protein-a-la-carte",
        "veggies-a-la-carte",
        "personalized-meal-planning",
        "chocolate-peanut-butter-protein-balls",
		"white-chocolate-macadamia-protein-balls",
        "decadent-cheesecakes",
		"ufn-power-mix-clean-fuel-snack"
    ];

	// Determine if we are on a cart-related page
    function isCartPage() {
        // Check for specific elements that are only present on cart or checkout pages
        return document.querySelector('.cart__checkout-button') || window.location.pathname.includes('/cart') || window.location.pathname.includes('/checkout');
    }
    
    // Calculate the total card discount
function calculateCartItemsAndDiscount() {
    setTimeout(function() {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                if (!cart || !cart.items) {
                    console.error("Cart data is invalid or empty:", cart);
                    return;
                }

                totalQualifyingItems = 0;
                totalCartQualifyingItems = 0;
                totalCostOfQualifyingMeals = 0;
                let qualifyingItems = [];
                let remainingMeals = membershipLimit;

                // Filter items based on exclusion and membership properties
                let cartItems = cart.items.filter(item => {
                    // Exclude items explicitly listed
                    if (excludedHandles.includes(item.handle)) return false;

                    // Check for ounces or tacos properties
                    const itemSize = item.options_with_values?.find(option => option.name === 'Protein Size')?.value;
                    const itemQuantity = item.options_with_values?.find(option => option.name === 'Quantity')?.value;

                    // If size or tacos property exists, ensure it matches the membership plan
                    if (itemSize && itemSize !== `${allowedSize}oz`) return false;
                    if (itemQuantity && itemQuantity !== `${allowedSize === '6' ? '3 Tacos' : '2 Tacos'}`) return false;

                    // If no conflicting properties, the item qualifies
                    return true;
                });

                console.log("Filtered Cart Items:", cartItems);

                // Sort items by price, highest first
                cartItems.sort((a, b) => b.price - a.price);

                for (let i = 0; i < cartItems.length; i++) {
                    const item = cartItems[i];
                    const itemQuantity = item.quantity;

                    totalCartQualifyingItems += itemQuantity;

                    const quantityToDiscount = Math.min(itemQuantity, remainingMeals);

                    if (quantityToDiscount > 0) {
                        totalCostOfQualifyingMeals += (item.price / 100) * quantityToDiscount;
                        qualifyingItems.push({ item: item, quantity: quantityToDiscount });
                        remainingMeals -= quantityToDiscount;
                    }
                }

                totalQualifyingItems = qualifyingItems.reduce((sum, qItem) => sum + qItem.quantity, 0);

                console.log("Total Qualifying Items in Cart:", totalCartQualifyingItems);
                console.log("Total Qualifying Items for Discount:", totalQualifyingItems);
                console.log("Total Cost of Qualifying Meals:", totalCostOfQualifyingMeals.toFixed(2));

                updateAnnouncementBar(totalQualifyingItems, totalCartQualifyingItems);
            })
            .catch(error => {
                console.error("Error fetching cart data:", error);
            });
    }, 1500);
}






	// Trigger Mechanic to create a new discount code in Shopify before loading the checkout page
	function applyDiscountCode(customerId, discountCode, totalCostOfQualifyingMeals) {
	    // Disable checkout button and show spinner
	    const checkoutButton = document.querySelector('.cart__checkout-button');
	    checkoutButton.disabled = true;
	    const spinner = document.getElementById("checkout__spinner");
	    const notice = document.getElementById("checkout__notice");
	    spinner.classList.remove("hidden");
	    notice.classList.remove("hidden");
	
	    fetch('https://webhooks.mechanic.dev/941725e4-4671-4b17-afa8-e11b26337092', {
	        method: 'POST',
	        headers: {
	            'Content-Type': 'application/json'
	        },
	        body: JSON.stringify({
	            customer_id: customerId,
	            discount_code: discountCode,
	            discount_amount: totalCostOfQualifyingMeals,
	            topic: 'user/discount/check'
	        })
	    })
	    .then(response => {
	        if (!response.ok) {
	            throw new Error("Webhook call failed: " + response.status);
	        }
	        //console.log("Webhook triggered successfully");
	        redirectToCheckoutWithDiscount(discountCode);
	    })
	    .catch(error => {
	        console.error("Error triggering Mechanic task:", error);
	        // Re-enable the button and hide spinner if there's an error
	        checkoutButton.disabled = false;
	        spinner.classList.add("hidden");
	        notice.classList.add("hidden");
	        checkoutButton.disabled = false;
	    });
	}

	// Redirect to checkout with the discount code pre-applied
	function redirectToCheckoutWithDiscount(discountCode) {
	    const checkoutUrl = `/checkout/?discount=${encodeURIComponent(discountCode)}`;
	    //console.log("Redirecting to:", checkoutUrl);
	
	    setTimeout(function() {
	        window.location.href = checkoutUrl;
	        // Optionally hide spinner after redirection is triggered
	        document.getElementById("checkout__spinner").classList.add("hidden");
	        document.getElementById("checkout__notice").classList.add("hidden");
	        const checkoutButton = document.querySelector('.cart__checkout-button');
	        checkoutButton.disabled = false;
	    }, 6500);
	}

	// Update the Announcement Bar
	function updateAnnouncementBar(totalQualifyingItems, totalCartQualifyingItems) {
	    var announcementBar = document.querySelector('#membership-status');
	    
	    if (!announcementBar) return;
	
	    announcementBar.style.visibility = "visible";
	
	    if (totalQualifyingItems < membershipLimit) {
	        announcementBar.textContent = `You've added ${totalQualifyingItems} out of ${membershipLimit} meals included in your ${membershipLevel} Membership.`;
	    } else if (totalQualifyingItems === totalCartQualifyingItems) {
	        announcementBar.textContent = `You've reached your ${membershipLevel} Membership limit of ${membershipLimit} meals and will be charged for any additional meals.`;
	    } else if (totalCartQualifyingItems > membershipLimit) {
	        announcementBar.textContent = `You've exceeded your ${membershipLevel} Membership limit of ${membershipLimit} meals and will be charged for additional meals.`;
	    } else {
	      announcementBar.textContent = `Please <a href="/account/login">log in</a> if you have a Membership Plan`;
	    }
	}


function getAllVariants() {
    // Check for a known <script> ID that contains the variants
    const productJsonScript = document.querySelector('#ProductJson-template');
    if (productJsonScript) {
        try {
            const productData = JSON.parse(productJsonScript.textContent);
            if (productData && productData.variants) {
                console.log("Found all variants:", productData.variants);
                return productData.variants; // Return the full variants array
            } else {
                console.warn("Expected variants structure not found in product data:", productData);
                return [];
            }
        } catch (error) {
            console.error("Error parsing product data from JSON script:", error);
            return [];
        }
    }
    console.warn("Product JSON script not found.");
    return [];
}


function getSelectedVariantId(sizeOption) {
    const variantMacros = window.variantMacros || {};
    const variantId = Object.keys(variantMacros).find(id => {
        const variant = variantMacros[id];
        return variant && variant.title === sizeOption; // Match title to sizeOption
    });
    return variantId ? parseInt(variantId, 10) : null;
}




function updateURLWithVariant(sizeOption) {
    const variantId = getSelectedVariantId(sizeOption);
    if (variantId) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState(null, '', url.toString());
        console.log(`Updated URL with variant ID: ${variantId}`);
    } else {
        console.warn("Variant ID not found for the selected option:", sizeOption);
    }
}


document.querySelectorAll('input[name="Protein Size-1"]').forEach(input => {
    input.addEventListener('change', () => {
        console.log(`Size option selected: ${input.value}`);
        updateURLWithVariant(input.value); // Pass the selected size (e.g., "4oz", "6oz")
    });
});

function selectMembershipVariant() {
    // Ensure productCollections is available
    if (!window.productCollections || !Array.isArray(window.productCollections)) {
        console.warn("Product collections are not available. Skipping membership variant selection.");
        return;
    }

    const productCollections = window.productCollections; // Use globally available variable
    console.log("Product Collections:", productCollections);

    // Handle Signature Meals
    if (productCollections.includes("signature-meals")) {
        // Handle size options
        const targetSize = allowedSize === '6' ? '6oz' : '4oz';
        const sizeOption = document.querySelector(`input[name="Protein Size-1"][value="${targetSize}"]`);

        if (sizeOption) {
            sizeOption.checked = true;
            sizeOption.dispatchEvent(new Event('change', { bubbles: true }));
            updateURLWithVariant(targetSize);
            console.log(`Programmatically selected ${targetSize} for Signature Meals.`);
        } else {
            console.warn(`Size option ${targetSize} not found for Signature Meals.`);
        }

        // Handle taco options
        const targetQuantity = allowedSize === '6' ? '3 Tacos' : '2 Tacos';
        const quantityOption = document.querySelector(`input[name="Quantity-1"][value="${targetQuantity}"]`);

        if (quantityOption) {
            quantityOption.checked = true;
            quantityOption.dispatchEvent(new Event('change', { bubbles: true }));
            console.log(`Programmatically selected ${targetQuantity} for Signature Meals.`);
        } else {
            console.warn(`Taco option ${targetQuantity} not found for Signature Meals.`);
        }
    } else if (productCollections.includes("custom-meals")) {
        const targetSize = allowedSize === '6' ? '6oz' : '4oz';
        const sizeOption = document.querySelector(`input[name="Protein Size-1"][value="${targetSize}"]`);

        if (sizeOption) {
            sizeOption.checked = true;
            sizeOption.dispatchEvent(new Event('change', { bubbles: true }));
            updateURLWithVariant(targetSize);
            console.log(`Programmatically selected ${targetSize} for Custom Meals.`);
        } else {
            console.warn(`Size option ${targetSize} not found for Custom Meals.`);
        }
    } else {
        console.log("Product does not belong to Signature or Custom Meals. Skipping variant selection.");
    }
}




	// Function to inject a warning based on the selected options
	function injectVariantWarning() {
	    const selectedProteinSize = document.querySelector('input[name="Protein Size-1"]:checked');
	    const selectedTacoQuantity = document.querySelector('input[name="Quantity-1"]:checked');
	    const macrosParagraph = document.querySelector('p.macros');
	    const allowedSize = membershipLevel ? membershipLevel.slice(-1) : null;
	
	    if (!macrosParagraph || (!selectedProteinSize && !selectedTacoQuantity)) return;
	
	    // Remove existing warnings
	    const existingWarning = document.getElementById('variant-warning');
	    if (existingWarning) existingWarning.remove();
	
	    let warningText = null;

		if (allowedSize === '4') {
		    if (selectedProteinSize && selectedProteinSize.value !== button_1["Protein Size"]) {
		        warningText = `Note: The selected ${selectedProteinSize.value} meal is not included in your ${allowedSize}oz membership. You will be charged for this meal.`;
		    } else if (selectedTacoQuantity && selectedTacoQuantity.value !== button_1["Quantity"]) {
		        warningText = `Note: The selected ${selectedTacoQuantity.value} option is not included in your ${allowedSize}oz membership. You will be charged for this option.`;
		    }
		} else if (allowedSize === '6') {
		    if (selectedProteinSize && selectedProteinSize.value !== button_2["Protein Size"]) {
		        warningText = `Note: The selected ${selectedProteinSize.value} meal is not included in your ${allowedSize}oz membership. You will be charged for this meal.`;
		    } else if (selectedTacoQuantity && selectedTacoQuantity.value !== button_2["Quantity"]) {
		        warningText = `Note: The selected ${selectedTacoQuantity.value} option is not included in your ${allowedSize}oz membership. You will be charged for this option.`;
		    }
		}
		
		if (warningText) {
		    const warningMessage = document.createElement('p');
		    warningMessage.id = 'variant-warning'; // Assign an ID for easy removal later
		    warningMessage.textContent = warningText;
		    warningMessage.style.color = 'red';
		    warningMessage.style.fontWeight = 'bold';
		    warningMessage.style.lineHeight = 'normal';
		    macrosParagraph.parentNode.insertBefore(warningMessage, macrosParagraph.nextSibling);
		}
	}



	function attachVariantEventListeners() {
	    
	    var proteinSizeOptions = document.querySelectorAll('input[name="Protein Size-1"]');
	    if (proteinSizeOptions.length > 0) {
	        proteinSizeOptions.forEach(function(option) {
	            option.addEventListener('change', function() {
	                console.log("Protein Size option changed to:", option.value);
	                injectVariantWarning(); // Re-inject the warning when protein size changes
	            });
	        });
	        console.log("Protein size listeners attached.");
	    }
	
	    var tacoQuantityOptions = document.querySelectorAll('input[name="Quantity-1"]');
	    if (tacoQuantityOptions.length > 0) {
	        tacoQuantityOptions.forEach(function(option) {
	            option.addEventListener('change', function() {
	                console.log("Taco Quantity option changed to:", option.value);
	                injectVariantWarning(); // Re-inject the warning when taco quantity changes
	            });
	        });
	        console.log("Taco quantity listeners attached.");
	    }
	}

	// Reattach listeners when the product options are updated
	function reattachVariantListenersOnChange() { 
	    document.body.addEventListener('click', function(event) {
	        if (event.target.matches('input[name="Protein Size-1"]')) {
	            attachVariantEventListeners();  // Reattach listeners if the radio buttons are re-rendered
	        }
	        if (event.target.matches('input[name="Quantity-1"]')) {
	            attachVariantEventListeners();  // Reattach listeners if the radio buttons are re-rendered
	        }
	    });
	}

	// Monitor cart updates using delegated event handling
	function monitorCartUpdates() {
	    
	    // Skip cart monitoring if we're not on the cart or checkout page
	    if (!isCartPage()) {
	        console.log("Not on cart or checkout page, skipping cart monitoring.");
	        return;
	    }
	
	    document.body.addEventListener('click', function(event) {
	        // Monitor add-to-cart, remove-from-cart, and delete cart button clicks
	        if (event.target.matches('.add-to-cart, .remove-from-cart') || event.target.closest('cart-remove-button') || event.target.closest('.cart__remove')) {
	            calculateCartItemsAndDiscount();  // Recalculate after cart updates
	            //console.log("Cart recalculated after update.");
	        }
	
	        // Monitor "Continue shopping" button clicks
	        if (event.target.tagName === 'BUTTON' && event.target.textContent.trim() === 'Continue shopping') {
	            calculateCartItemsAndDiscount();  // Recalculate after "Continue shopping" click
	            //console.log("Cart recalculated after continue shopping.");
	        }
	    });
	
	    document.body.addEventListener('change', function(event) {
	        // Monitor quantity changes in the cart
	        if (event.target.matches('input[type="number"].quantity__input')) {
	            calculateCartItemsAndDiscount();  // Recalculate after quantity changes
	            //console.log("Cart recalculated after quantity change.");
	        }
	    });
	}
	
	// Function to monitor and update announcement bar globally (on all pages)
	function monitorGlobalCartUpdates() {
	    document.body.addEventListener('click', function(event) {
	        // Monitor add-to-cart button clicks and other interactions
	        if (event.target.matches('button[name="add"]')) {
	            fetch('/cart.js')
	                .then(response => response.json())
	                .then(cart => {
	                    calculateCartItemsAndDiscount(cart);  // Recalculate cart data
	                    //console.log("Cart recalculated. Updating announcement bar.");
	                })
	                .catch(error => {
	                    console.error("Error fetching cart data:", error);
	                });
	        }
	    });
	}

	// Monitor the checkout button and request a discount code
	function monitorCheckoutButton() {
	    
	    // Skip cart monitoring if we're not on the cart or checkout page
	    if (!isCartPage()) {
            //console.log("Not on cart or checkout page, skipping cart monitoring.");
            return;
        }
	    
	    const checkoutButton = document.querySelector('.cart__checkout-button');
	
	    if (checkoutButton) {
	        checkoutButton.addEventListener('click', async function(event) {
	            event.preventDefault();
	            
	            // Retrieve the Gate Code value
	            const gateCode = document.querySelector('#Cart-gatecode') ? document.querySelector('#Cart-gatecode').value : '';
	
	            // Update the cart with the Gate Code if it exists
	            if (gateCode) {
	                try {
	                    await fetch('/cart/update.js', {
	                        method: 'POST',
	                        headers: {
	                            'Content-Type': 'application/json'
	                        },
	                        body: JSON.stringify({
	                            attributes: {
	                                'gate-code': gateCode
	                            }
	                        })
	                    });
	                    //console.log('Gate Code added to cart:', gateCode);
	                } catch (error) {
	                    console.error('Error updating cart with Gate Code:', error);
	                }
	            }
	
	            if (totalCostOfQualifyingMeals > 0) {
	                try {
	                    //console.log("Applying Discount Code");
	                    const discountCode = generateDiscountCodeString(customerId, membershipLevel)
	                    applyDiscountCode(customerId, discountCode, totalCostOfQualifyingMeals);
	                } catch (error) {
	                    console.error("Error during checkout process:", error);
	                }
	            } else {
	                //console.log("No qualifying items in the cart.");
	            }
	        });
	    }
	}
		
	// Call both functions to ensure listeners are attached
	window.addEventListener('load', function() {
		if (!isCartPage()) {  // Run on non-cart pages
	        fetch('/cart.js')
	            .then(response => response.json())
	            .then(cart => {
	                calculateCartItemsAndDiscount(cart);  // Recalculate on non-cart pages as well
	                //console.log("Page loaded. Announcement bar updated on non-cart page.");
	            })
	            .catch(error => {
	                console.error("Error fetching cart data:", error);
	            });
	    }
	    selectMembershipVariant(); // Auto-select correct variant for membership
        console.log("Membership variant selection initialized.");
	    monitorGlobalCartUpdates();  // Attach global listeners for cart updates
	    attachVariantEventListeners();  // Attach event listeners on initial load
	    reattachVariantListenersOnChange();  // Ensure listeners are reattached if needed
	    injectVariantWarning();  // Run initially on page load to check the current state
	});

    // Only run cart-related functions on the cart/checkout pages
	if (isCartPage()) {
	    monitorCartUpdates(); // Monitor cart updates
	    monitorCheckoutButton(); // Monitor checkout button for discount creation
	    calculateCartItemsAndDiscount();  // Initial calculation of cart items and discount
	}
	
});
